import { Link } from 'react-router-dom';

// components
import HeaderBtn from '../header-btn/HeaderBtn';

// assets
import whatnotIcon from '../../../../../assets/system/logos/whatnot-logo.png';

export default function HeaderWhatnotPill({ navigateTo }) {
    return (
        <Link to={navigateTo} style={{ textDecoration: 'none', color: 'inherit' }}>
            <HeaderBtn>
                <img src={whatnotIcon} alt='Whatnot icon' />
            </HeaderBtn>
        </Link>
    );
}
